import React from "react";
import { AlertTriangle, CheckCircle2, XCircle } from "lucide-react";

const notToPublish = [
  "Copied or plagiarized content",
  "Copyrighted content without permission",
  "Misleading travel information",
  "Personal information of other people",
  "Offensive or hateful content",
  "Unsafe or illegal activity instructions",
  "Spam or promotional content",
  "Fake reviews or experiences",
];

const beforePublish = [
  "My blog is original",
  "My title clearly describes the blog",
  "My information is accurate",
  "I checked spelling and grammar",
  "I have used relevant images",
  "I haven't included copyrighted content",
  "I selected the correct category",
  "My blog provides value to travelers",
];

export default function PublishingRules() {
  return (
    <section className="max-w-7xl mx-auto px-6 sm:px-10 py-2">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white border border-slate-100 shadow-sm rounded-2xl p-6 pb-0 flex flex-col">
          <div className="flex items-center gap-3 mb-4">
            <span className="w-10 h-10 rounded-full bg-red-50 text-red-500 flex items-center justify-center shrink-0">
              <AlertTriangle className="w-5 h-5" />
            </span>
            <h3 className="font-bold text-slate-900 text-base">
              What Not to Publish
            </h3>
          </div>
          <p className="text-sm font-medium text-slate-800 mb-3">
            Please don't publish:
          </p>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-1 gap-y-3 text-[12px] text-slate-600 mb-4  ">
            {notToPublish.map((item) => (
              <li key={item} className="flex items-start gap-1">
                <XCircle className="w-4 h-4 text-red-500 shrink-0 mt-0.5" />
                {item}
              </li>
            ))}
          </ul>
          <img
            src="/img/dashboard/writer-guidelines-not-publish.svg"
            alt="Do not publish"
            className="w-full  mx-auto h-[300px] object-contain"
          />
        </div>

        <div className="bg-white border border-slate-100 shadow-sm rounded-2xl p-6 flex flex-col">
          <div className="flex items-center gap-3 mb-4">
            <span className="w-10 h-10 rounded-full bg-emerald-50 text-emerald-600 flex items-center justify-center shrink-0">
              <CheckCircle2 className="w-5 h-5" />
            </span>
            <h3 className="font-bold text-slate-900 text-base">
              Before You Publish
            </h3>
          </div>
          <p className="text-sm font-medium text-slate-800 mb-3">
            Please confirm:
          </p>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-2 gap-y-2 text-[12px] text-slate-600 mb-6 ">
            {beforePublish.map((item) => (
              <li key={item} className="flex items-start gap-2">
                <CheckCircle2 className="w-4 h-4 text-emerald-500 shrink-0 mt-0.5" />
                {item}
              </li>
            ))}
          </ul>
          <img
            src="/img/dashboard/writer-guidelines-checklist.svg"
            alt="Checklist"
            className="w-[200px] max-w-xs mx-auto h-[300px] object-contain"
          />
        </div>
      </div>
    </section>
  );
}
